module.exports = __webpack_public_path__ + "img/Caitlyn.ce3ba1cb.png";